import './lncanada1/style';
import FormStructure from './lncanada1/form_structure';

export default FormStructure;